module.exports = __webpack_public_path__ + "static/img/about2.1a0ee077.png";